import React from 'react';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';
import { PopoverMenu, PopoverMenuItem } from '@futrli/ui-components/components/popover-menu/popover-menu';
import { useSidebarContext } from '@futrli/shared-services/contexts/sidebar-context/useSidebarContext';

interface CreateDashboardPopoverProps {
  variant?: 'primary' | 'secondary';
}

export const CreateDashboardPopover = ({ variant = 'primary' }: CreateDashboardPopoverProps) => {
  const { dashboard, dashboardTemplate } = useSidebarContext();

  const items: PopoverMenuItem[] = [
    {
      label: <FormattedMessage id="reporting.dashboard" defaultMessage="Dashboard" />,
      onClick: () => dashboard.open()
    },
    {
      label: <FormattedMessage id="predict.create.dashboard_template_v2" defaultMessage="Dashboard template" />,
      onClick: () => dashboardTemplate.open()
    }
  ];

  return (
    <PopoverMenu
      items={items}
      renderOpenComponent={({ onClick, ref, 'aria-expanded': ariaExpanded }) => (
        <Button
          buttonType={variant}
          iconType="dropdown"
          iconPosition="after"
          onClick={onClick}
          ref={ref}
          aria-expanded={ariaExpanded}
        >
          {variant === 'primary' ? (
            <FormattedMessage id="common.create" defaultMessage="Create" />
          ) : (
            <FormattedMessage id="predict.dashboards.create_dashboard" defaultMessage="Create dashboard" />
          )}
        </Button>
      )}
    />
  );
};
